import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import NumberOfByesPopupDetails from './NumberOfByesPopupDetails.vue'

export const NumberOfByesPopup = new PopupBuilder('Number of Byes')
  .appendBody(NumberOfByesPopupDetails)
  .build()
